module.exports = __webpack_public_path__ + "5c589879413ed95b24f8ad5f12642bb1.png";